

































import { Component, Prop, Vue } from 'vue-property-decorator'

import { CategoryList } from '@/models/CategoryList'
import { Category } from '@/models/Category'
import ToolTip from '@/components/form/ToolTip.vue'
import DropdownList from '@/components/form/DropdownList.vue'

import { extend } from 'vee-validate'
import { LookupService } from '@/services/LookupService'

extend('selectCategory', {
  validate(value: number): boolean {
    return value > 0
  },
  message: "Please select a valid category"
})

@Component({
  components: {
    ToolTip,
    DropdownList
  },
  name: 'CategorySelector'
})
export default class CategorySelector extends Vue {
  @Prop( { default: false }) showSearchButtons!: boolean
  @Prop( { default: '' }) className!: string
  @Prop( { default: false }) required!: boolean
  @Prop( { default: false }) showSeparator!: boolean
  @Prop( { default: false }) showToolTip!: boolean
  @Prop( { default: '' }) label!: string
  @Prop( { required: false, default: "" } ) name!: string

  @Prop( { required: false, default: null } ) value!: Category | null

  initialising = true
  private initialValue!: Category | null
  private selectedCategoryId = 0
  showProgressIndicator = false
  levels: CategoryList[] = []
  private lookupService= new LookupService()

  private maxLevel = 3

  get selectedCategory(): Category | null {
    return this.value
  }
  set selectedCategory(val: Category | null) {
    this.$emit('input', val)
  }

  addLevel (level: number): void {
    this.clearLevel(level)
    if (level > 0) {
      this.required = true
    }
    this.getLevel(level)
  }

  removeLevel (level: number): void {
    this.clearLevel(level)

    if (this.levels.length > 0) {
      this.selectedCategoryId = this.levels[this.levels.length - 1].categoryId
      if (this.selectedCategoryId > 0) {
        this.getLevel(this.levels.length)
      }
    }
  }

  clearLevel (level: number): void {
    if (level < 0) {
      level = 0
    }

    // Remove all levels above the current one.
    while (this.levels.length > level) {
      this.levels.pop()
    }
  }

  focusDropdown(level: number): void {
    this.$nextTick(() => {
      const elem = this.$refs[`level_${level}`] as HTMLInputElement;
      if (elem && elem.focus) {
        elem.focus()
      }
//      (this.$refs[`level_${level}`] as HTMLInputElement & {focus: () => void }).focus()
    });
  }

  getLevel (level: number): void {
    let newLevel = level
    if (newLevel > this.levels.length) {
      newLevel = this.levels.length
    }

    if (newLevel < 0) {
      newLevel = 0
    }
    const parentCategory = newLevel === 0 ? 0 : this.levels[newLevel - 1].categoryId

    this.showProgressIndicator = true

    

    this.lookupService.GetCategories(parentCategory)
      .then((response) => {
        if (response.length === 0) {
          this.clearLevel(newLevel)
          return
        }

        // Add the "select a... " option to the start.
        response.unshift({
          id: 0,
          name: this.selectOptionLabel(this.levels.length),
          ancestors: []
        });

        if (this.levels.length > newLevel) {
          this.levels[newLevel].list = response
          this.levels[newLevel].categoryId = 0
        } else {
          const level = {
            list: response,
            categoryId: 0,
            active: false
          }

          if (this.initialValue !== null) {
            let foundCategory: Category | undefined = undefined
            if (this.initialValue?.ancestors.length > this.levels.length) {
              foundCategory = level.list.find(c => {
                return c.id === this.initialValue?.ancestors[this.levels.length]?.id
              })
              if (foundCategory !== undefined) {
                level.categoryId = foundCategory.id
                level.active = true
              }
            } else {
              foundCategory = level.list.find(c => {
                return c.id === this.initialValue?.id
              })
              if (foundCategory !== undefined) {
                level.categoryId = foundCategory.id
                level.active = true
              }
            }

          }

          this.levels.push(level)

          if (this.initialValue != null) {
            if (this.initialValue?.ancestors.length === this.levels.length - 1) {
              // Clear this so we don't go through it again.
              this.initialValue = null
            } else {
              // Call the next level...
              this.getLevel(this.levels.length)
            }
          } else {
            this.focusDropdown(this.levels.length - 1)
          }
        }
        this.showProgressIndicator = false
      })
      .catch((error) => {
        console.log(error)
        this.showProgressIndicator = false
      })
  }

  categorySelected (level: number): void {
    let currentCategory: Category | undefined = undefined

    if (level >= 0 && level < this.levels.length) {
      if (this.levels[level].categoryId > 0) {
        this.selectedCategoryId = this.levels[level].categoryId

        currentCategory = this.levels[level].list.find(c => {
          return c.id === this.selectedCategoryId
        })
        if (level <= this.maxLevel) {
          this.addLevel(level + 1)
        }
      } else {
        this.removeLevel(level + 1)
        if (level > 0) {
          this.selectedCategoryId = this.levels[level - 1].categoryId

          currentCategory = this.levels[level - 1].list.find(c => {
            return c.id === this.selectedCategoryId
          })
        }
      }
    }
    if (currentCategory === undefined) {
      this.selectedCategory = null
    } else {
      this.selectedCategory = currentCategory
    }
  }

  canRefine (level: number): boolean {
    return level > 0 &&
          level === this.levels.length - 1 &&
          this.levels[level].categoryId === 0
  }

  selectOptionLabel (level: number): string {
    return (level > 0) ?
        'Select sub-category' :
        'Select category'
  }

  gotFocus (level: number): void {
    this.levels[level].active = true
  }

  lostFocus (level: number): void {
    this.levels[level].active = false
  }

  created (): void {
    this.initialValue = this.selectedCategory
    this.getLevel(0)
  }
}
